import {
    Component,
    OnInit,
    ChangeDetectorRef,
    HostBinding,
    Renderer2,
    RendererFactory2,
    ViewChild,
    ElementRef
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { BreadcrumbSharedService } from '../../../app-platform-breadcrumb-shared-module';
import { ShellDomainProvider } from '../../../core';

@Component({
    selector: 'app-platform-breadcrumb',
    templateUrl: './platform-breadcrumb.component.html',
    styleUrls: ['./platform-breadcrumb.component.scss'],
    standalone: false
})
export class PlatformBreadCrumbComponent implements OnInit {
    @HostBinding('class.mat-accent-bg')
    @HostBinding('class.is-preview-open')
    isPreviewOpen;
    @HostBinding('class.is-preview-close') isPreviewClose;

    @ViewChild('breadCrumbView') breadCrumbView: ElementRef;
    subscription: Subscription;
    staticSubscription: Subscription;
    userScrollSubscription: Subscription;

    private renderer: Renderer2;
    public static internalBreadcrumbs: BreadCrumb[] = [];
    private _unsubscribeAll: Subject<void>;
    breadcrumbs: BreadCrumb[];
    nonHideBreadcrumbs: BreadCrumb[];
    crumbLabel: string;
    crumbtype: string;
    tempBreadcrumbs: any;
    tempUrl: any;
    styleObj: any;
    breadCrumbWithMenuBar: boolean = ShellDomainProvider['api'] && ShellDomainProvider['api']['breadCrumbWithMenuBar'];
    constructor(
        private cdRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private rendererFactory: RendererFactory2,
        private breadcrumbSharedService: BreadcrumbSharedService
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this._unsubscribeAll = new Subject();
        this.breadcrumbs = [];
        this.nonHideBreadcrumbs = [];
    }

    ngOnInit() {
        this.breadcrumbSharedService.currentBreadcrumbData
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response !== 'DEFAULT_MESSAGE') {
                    this.updateBreadcrumb(response);
                }
            });

        BreadcrumbSharedService.currentStaticBreadcrumbData
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response !== 'DEFAULT_MESSAGE') {
                    this.updateBreadcrumb(response);
                }
            });
    }

    ngAfterViewInit() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
            this.renderer.setStyle(this.breadCrumbView.nativeElement, 'display', 'block');
            let currentUrl = event['urlAfterRedirects'];
            let root: ActivatedRoute = this.activatedRoute.root;
            if (currentUrl.split('?')[0] === this.tempUrl) {
                this.tempUrl = currentUrl.split('?')[0];
            } else {
                PlatformBreadCrumbComponent.internalBreadcrumbs = this.getBreadcrumbs(root);
                this.breadcrumbs = PlatformBreadCrumbComponent.internalBreadcrumbs;
                this.nonHideBreadcrumbs = this.breadcrumbs.filter(breadcrumb => !breadcrumb.isHide);
                this.tempUrl = currentUrl.split('?')[0];
            }
        });

        this.breadcrumbSharedService
            .getUserScrollEvent()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((event: any) => {
                if (event.target.scrollTop === 0) {
                    this.renderer.setStyle(this.breadCrumbView.nativeElement, 'display', 'block');
                    //document.getElementById("breadcrumb").style.display = "block";
                } else if (event.target.scrollTop > 0) {
                    this.renderer.setStyle(this.breadCrumbView.nativeElement, 'display', 'none');
                    //document.getElementById("breadcrumb").style.display = "none";
                }
            });
    }

    public getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: BreadCrumb[] = []): BreadCrumb[] {
        const ROUTE_DATA_BREADCRUMB = 'breadcrumb';
        const ROUTE_DATA_ISTRANSLATE = 'isTranslate';
        let isHide: boolean = false;
        let isTranslate: boolean = false;
        let children: ActivatedRoute[] = route.children;
        let label: string;
        let crumbType: string = 'link';
        if (children.length === 0) {
            return breadcrumbs;
        }
        for (let child of children) {
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }
            const routeArray = child.snapshot.url.map(segment => segment.path);
            for (let i = 0; i < routeArray.length; i++) {
                label = routeArray[i];
            }
            for (let i = 0; i < routeArray.length; i++) {
                if (Object.keys(child.snapshot.params).length > 0) {
                    if (this.isParam(child.snapshot.params, routeArray[i])) {
                        label = routeArray[i];
                    } else {
                        label = child.snapshot.data[ROUTE_DATA_BREADCRUMB];
                        isTranslate = child.snapshot.data[ROUTE_DATA_ISTRANSLATE];
                        crumbType = child.snapshot.data['breadcrumbType'];
                        isHide = child.snapshot.data['isHide'];
                    }
                } else {
                    label = child.snapshot.data[ROUTE_DATA_BREADCRUMB];
                    isTranslate = child.snapshot.data[ROUTE_DATA_ISTRANSLATE];
                    crumbType = child.snapshot.data['breadcrumbType'];
                    isHide = child.snapshot.data['isHide'];
                }
                const routeURL = routeArray[i];

                url += `/${routeURL}`;
                const breadcrumb: BreadCrumb = {
                    label: label,
                    params: child.snapshot.params,
                    url: url,
                    type: crumbType,
                    isTranslate: isTranslate,
                    isHide: isHide
                };
                breadcrumbs.push(breadcrumb);
            }
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
        return [];
    }

    public isParam(params: Params, segment: string) {
        for (const key of Object.keys(params)) {
            const value = params[key];
            if (value === segment) {
                return true;
            }
        }
        return false;
    }

    public updateBreadcrumb(data: BreadCrumb) {
        if (!data) return;
        this.tempBreadcrumbs = PlatformBreadCrumbComponent.internalBreadcrumbs;
        this.tempBreadcrumbs.forEach((item: BreadCrumb, index: number) => {
            if (Array.isArray(data)) {
                const result = data.find(x => x.urlPart === item.label);
                if (result) {
                    this.modifyEachBreadcrumb(index, result);
                }
            } else {
                if (item.label === data.urlPart) {
                    this.modifyEachBreadcrumb(index, data);
                } else if (item.url === data.urlPart) {
                    this.modifyEachBreadcrumb(index, data);
                }
            }
        });
        this.breadcrumbs = PlatformBreadCrumbComponent.internalBreadcrumbs;
        this.nonHideBreadcrumbs = this.breadcrumbs.filter(breadcrumb => !breadcrumb.isHide);
        this.cdRef.detectChanges();
    }

    modifyEachBreadcrumb(index: number, data: BreadCrumb) {
        PlatformBreadCrumbComponent.internalBreadcrumbs[index].label =
            data.label || PlatformBreadCrumbComponent.internalBreadcrumbs[index].label;
        PlatformBreadCrumbComponent.internalBreadcrumbs[index].type =
            data.type || PlatformBreadCrumbComponent.internalBreadcrumbs[index].type;
        PlatformBreadCrumbComponent.internalBreadcrumbs[index].isTranslate = data.isTranslate;
        PlatformBreadCrumbComponent.internalBreadcrumbs[index].isHide = data.isHide;
        PlatformBreadCrumbComponent.internalBreadcrumbs[index].url =
            data.url || PlatformBreadCrumbComponent.internalBreadcrumbs[index].url;
        PlatformBreadCrumbComponent.internalBreadcrumbs[index].queryParams =
            data.queryParams || PlatformBreadCrumbComponent.internalBreadcrumbs[index].queryParams;
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}

export interface BreadCrumb {
    label: string;
    params: Params;
    url: string;
    urlPart?: string;
    type: string;
    isTranslate?: boolean;
    isHide?: boolean;
    queryParams?: object;
}
